export const TREATMENT_API_IDS = {
  ALWAYS_SUPPORTED: 'always-supported',
  VENEERS: 1,
  BONDING: 2,
  BRACES_INVISALIGN: 3,
  WISDOM_TEETH_REMOVAL: 4,
  BRIDGE_DENTURES: 5,
  WHITENING: 7,
  IMPLANT: 8,
  CROWN_CAP: 9,
  ROOT_CANAL: 10,
  TOOTH_EXTRACTION: 11,
  GUM_SURGERY: 12,
  SLEEP_APNEA: 13,
  TMJ_JAW_CLENCHING: 14,
  CHECKUP_CLEANING: 15,
  CAVITY_FILLING: 16,
};

export const TREATMENTS = {
  CHECKUP_CLEANING: {
    id: 1,
    title: 'New Patient Exam + Cleaning',
    apiId: TREATMENT_API_IDS.CHECKUP_CLEANING,
  },
  TOOTHACHE_GENERAL_PAIN: {
    id: 2,
    title: 'Toothache / General Pain',
    apiId: TREATMENT_API_IDS.ALWAYS_SUPPORTED,
  },
  SENSITIVE_BLEEDING_GUMS: {
    id: 3,
    title: 'Sensitive / Bleeding Gums',
    apiId: TREATMENT_API_IDS.ALWAYS_SUPPORTED,
  },
  TMJ_JAW_CLENCHING: {
    id: 4,
    title: 'TMJ / Jaw Clenching',
    apiId: TREATMENT_API_IDS.TMJ_JAW_CLENCHING,
  },
  NIGHT_GUARD: {
    id: 5,
    title: 'Night Guard',
    apiId: TREATMENT_API_IDS.ALWAYS_SUPPORTED,
  },
  CAVITY_FILLING: {
    id: 6,
    title: 'Cavity / Filling',
    apiId: TREATMENT_API_IDS.CAVITY_FILLING,
  },
  CHIPPED_BROKEN_TOOTH: {
    id: 7,
    title: 'Chipped / Broken Tooth',
    apiId: TREATMENT_API_IDS.ALWAYS_SUPPORTED,
  },
  ROOT_CANAL: {
    id: 8,
    title: 'Root Canal',
    apiId: TREATMENT_API_IDS.ROOT_CANAL,
  },
  NEW_CROWN_CAP: {
    id: 9,
    title: 'New Crown / Cap',
    apiId: TREATMENT_API_IDS.CROWN_CAP,
  },
  LOOSE_CROWN_CAP: {
    id: 10,
    title: 'Loose Crown / Cap',
    apiId: TREATMENT_API_IDS.CROWN_CAP,
  },
  LOST_CROWN_CAP: {
    id: 11,
    title: 'Lost Crown / Cap',
    apiId: TREATMENT_API_IDS.CROWN_CAP,
  },
  TOOTH_EXTRACTION_WISDOM: {
    id: 12,
    title: 'Tooth Extraction (Wisdom)',
    apiId: TREATMENT_API_IDS.WISDOM_TEETH_REMOVAL,
  },
  TOOTH_EXTRACTION_NON_WISDOM: {
    id: 13,
    title: 'Tooth Extraction (Non-Wisdom)',
    apiId: TREATMENT_API_IDS.TOOTH_EXTRACTION,
  },
  MISSING_TOOTH: {
    id: 14,
    title: 'Missing Tooth',
    apiId: TREATMENT_API_IDS.ALWAYS_SUPPORTED,
  },
  IMPLANT: {
    id: 15,
    title: 'Implant',
    apiId: TREATMENT_API_IDS.IMPLANT,
  },
  BRIDGE_DENTURES: {
    id: 16,
    title: 'Bridge / Dentures',
    apiId: TREATMENT_API_IDS.BRIDGE_DENTURES,
  },
  NEW_RETAINER: {
    id: 17,
    title: 'New Retainer',
    apiId: TREATMENT_API_IDS.BRACES_INVISALIGN,
  },
  BROKEN_RETAINER: {
    id: 18,
    title: 'Broken Retainer',
    apiId: TREATMENT_API_IDS.BRACES_INVISALIGN,
  },
  BRACES_INVISALIGN: {
    id: 19,
    title: 'Braces / Invisalign',
    apiId: TREATMENT_API_IDS.BRACES_INVISALIGN,
  },
  WHITENING: {
    id: 20,
    title: 'Whitening',
    apiId: TREATMENT_API_IDS.WHITENING,
  },
  VENEERS: {
    id: 21,
    title: 'Veneers',
    apiId: TREATMENT_API_IDS.VENEERS,
  },
  OTHER: {
    id: 'other',
    title: 'Other',
  },
};

export const treatmentCheckupCleaning = TREATMENTS.CHECKUP_CLEANING;

const commonDentalIssues = {
  header: 'Common Dental Issues',
  values: [
    TREATMENTS.TOOTHACHE_GENERAL_PAIN,
    TREATMENTS.SENSITIVE_BLEEDING_GUMS,
    TREATMENTS.TMJ_JAW_CLENCHING,
    TREATMENTS.NIGHT_GUARD,
  ],
};

const toothRepair = {
  header: 'Tooth Repair',
  values: [
    TREATMENTS.CAVITY_FILLING,
    TREATMENTS.CHIPPED_BROKEN_TOOTH,
    TREATMENTS.ROOT_CANAL,
    TREATMENTS.NEW_CROWN_CAP,
    TREATMENTS.LOOSE_CROWN_CAP,
    TREATMENTS.LOST_CROWN_CAP,
  ],
};

const toothExtractionReplacement = {
  header: 'Tooth Extraction / Replacement',
  values: [
    TREATMENTS.TOOTH_EXTRACTION_WISDOM,
    TREATMENTS.TOOTH_EXTRACTION_NON_WISDOM,
    TREATMENTS.MISSING_TOOTH,
    TREATMENTS.IMPLANT,
    TREATMENTS.BRIDGE_DENTURES,
  ],
};

const orthodontics = {
  header: 'Orthodontics',
  values: [
    TREATMENTS.NEW_RETAINER,
    TREATMENTS.BROKEN_RETAINER,
    TREATMENTS.BRACES_INVISALIGN,
  ],
};

const cosmetic = {
  header: 'Cosmetic',
  values: [TREATMENTS.WHITENING, TREATMENTS.VENEERS],
};

const otherTreatments = {
  header: 'Other Treatments',
  values: [TREATMENTS.OTHER],
};

export const specificConcernsTreatments = [
  commonDentalIssues,
  toothRepair,
  toothExtractionReplacement,
  orthodontics,
  cosmetic,
  otherTreatments,
];

export const getTreatmentIndex = (id) => {
  const allTreatments = specificConcernsTreatments.map((s) => s.values).flat();
  allTreatments.unshift(treatmentCheckupCleaning);

  return allTreatments.findIndex((t) => t.id === id);
};
